import { InjectionToken } from '@angular/core';

export const SOFTLINE_SECRET_TERMINAL_PASSWORD = new InjectionToken('SOFTLINE_TERMINAL_PASSWORD', {
  providedIn: 'root',
  factory: () => 'IDDQD'
});
